import { c as _c } from "react/compiler-runtime";
import { CheckBoxSwitcher, Checkbox, DatePicker, FormInput, FormSelect, Hint } from '@systemeio/ui';
import { getCourseBundleAccessTypeDataOptions } from 'modules/courses/bundles/course-bundle/enums/access-type-enum';
import { AccessTypeEnum } from 'modules/courses/courses/curriculum/enums/access-type-enum';
import { DigitalResourcesTypeEnum, DigitalResourcesTypeTitles } from 'modules/digital-product/enums/digital-resources-type-enum';
import CourseModulesSkeleton from 'modules/digital-product/resources/components/course-module-skeleton';
import DigitalResourceWrapper from 'modules/digital-product/resources/components/digital-resource-wrapper';
import { DigitalResourceEditType } from 'modules/digital-product/resources/types/digital-resource-edit-interface';
import { getDefaultResourceValue } from 'modules/digital-product/resources/utils/get-default-resource-value';
import { getGrantCourseAccessUrl } from 'modules/digital-product/resources/utils/get-grant-course-access-url';
import { DigitalProductErrorInterface } from 'modules/digital-product/types/digital-product-interface';
import React, { FC } from 'react';
import TransLoco from 'shared/components/trans-loco';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { getToday } from 'shared/utils/get-dates';
import { getCourseAccessTypeDataOptions } from 'modules/courses/courses/curriculum/utils/get-course-access-type-data-options';
import { isPartialType } from 'modules/courses/courses/curriculum/utils/is-partial-type';
interface ResourcesSelectProps {
  resources: DigitalResourceEditType[];
  onChangeResources: (resources: DigitalResourceEditType[]) => void;
  errors: DigitalProductErrorInterface['resources'];
  numberOfExistingResources: number;
}
const ResourcesSelect: FC<ResourcesSelectProps> = t0 => {
  const $ = _c(30);
  const {
    resources,
    onChangeResources,
    errors,
    numberOfExistingResources
  } = t0;
  const {
    user,
    isRootAdmin,
    intlLocale
  } = useUser();
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== t) {
    t1 = getCourseAccessTypeDataOptions(t);
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const courseAccessData = t1;
  let t2;
  if ($[2] !== t) {
    t2 = getCourseBundleAccessTypeDataOptions(t);
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const courseBundleAccessData = t2;
  let t3;
  if ($[4] !== isRootAdmin || $[5] !== t) {
    t3 = Object.values(DigitalResourcesTypeEnum).filter(el => isRootAdmin ? true : el !== DigitalResourcesTypeEnum.systemeio_plan).filter(_temp)?.map(el_1 => ({
      id: el_1,
      caption: t(DigitalResourcesTypeTitles[el_1])
    }));
    $[4] = isRootAdmin;
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const digitalResourceTypeData = t3;
  let t4;
  if ($[7] !== onChangeResources || $[8] !== resources) {
    t4 = (idx, data) => {
      const updatedResources = resources.map((el_2, i) => {
        if (i === idx) {
          if (data) {
            return getDefaultResourceValue(data);
          } else {
            return {
              type: undefined
            };
          }
        }
        return el_2;
      });
      onChangeResources(updatedResources);
    };
    $[7] = onChangeResources;
    $[8] = resources;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const onChangeType = t4;
  let t5;
  if ($[10] !== onChangeResources || $[11] !== resources) {
    t5 = (idx_0, data_0) => {
      const updatedResources_0 = resources.map((el_3, i_0) => {
        if (i_0 === idx_0 && el_3.type === data_0.type) {
          return {
            ...el_3,
            ...data_0
          } as DigitalResourceEditType;
        }
        return el_3;
      });
      onChangeResources(updatedResources_0);
    };
    $[10] = onChangeResources;
    $[11] = resources;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const onChangeResource = t5;
  let t6;
  if ($[13] !== courseAccessData || $[14] !== courseBundleAccessData || $[15] !== digitalResourceTypeData || $[16] !== errors || $[17] !== intlLocale || $[18] !== numberOfExistingResources || $[19] !== onChangeResource || $[20] !== onChangeResources || $[21] !== onChangeType || $[22] !== resources || $[23] !== t || $[24] !== user?.createdAt || $[25] !== user?.dashboardLocale || $[26] !== user?.timezone) {
    t6 = resources.map((resource, idx_1) => {
      switch (resource.type) {
        case DigitalResourcesTypeEnum.membership_course:
          {
            return <DigitalResourceWrapper key={idx_1} resource={resource} onDelete={() => {
              onChangeResources(resources.filter((__5, i_7) => i_7 !== idx_1));
            }}>{data_13 => <><FormSelect key={`resource-type-selector-${idx_1}`} placeholder={t("dashboard.funnel.configuration.common.digital_resources.placeholder")} data={digitalResourceTypeData} onChange={data_14 => onChangeType(idx_1, data_14)} value={resource.type} /><div className="ml-4 flex flex-col gap-3"><FormSelect key={`course-selector-${idx_1}`} placeholder={t("dashboard.funnel.configuration.common.offer_resources.choose_course")} value={resource.course} data={data_13.coursesData} onChange={value_5 => {
                    onChangeResource(idx_1, {
                      type: resource.type,
                      course: value_5
                    });
                  }} error={errors[numberOfExistingResources + idx_1]?.course?.join(", ")} />{resource.course && <FormSelect key={`access-type-selector-${idx_1}`} placeholder={t("dashboard.funnel.configuration.common.offer_resources.choose_course_access_type")} value={resource.enrollmentAccessType || undefined} data={courseAccessData} onChange={data_15 => onChangeResource(idx_1, {
                    type: resource.type,
                    enrollmentAccessType: data_15,
                    accessFrom: undefined,
                    expirationPeriod: undefined,
                    modules: []
                  })} error={errors[numberOfExistingResources + idx_1]?.enrollmentAccessType?.join(", ")} />}{resource.enrollmentAccessType && isPartialType(resource.enrollmentAccessType) && <div key={`modules-selector-${idx_1}`} className={`flex-col gap-1 text-sm font-medium ${data_13.courseModulesData && data_13.courseModulesData.length === 0 ? "hidden" : "flex"}`}><ul className="flex flex-row flex-wrap gap-5">{data_13.courseModulesData ? data_13.courseModulesData.map(module => {
                        const isSelected = !!resource.modules?.find(el_4 => el_4 === module.id) || false;
                        return <li key={module.id}><Checkbox value={isSelected} label={<div className={`flex items-center gap-1.5 ${isSelected && "[&>svg]:fill-brand-primary [&>svg]:main-transition-colors"}`}>{module.caption}</div>} onChange={() => onChangeResource(idx_1, {
                            type: resource.type,
                            modules: isSelected ? resource.modules?.filter(el_5 => el_5 !== module.id) : [...(resource.modules || []), module.id]
                          })} /></li>;
                      }) : <CourseModulesSkeleton />}</ul></div>}{resource.enrollmentAccessType && <><div className="flex min-h-[42px] items-center gap-5" key={`access-from-selector-${idx_1}`}><CheckBoxSwitcher label={<Hint label={<TransLoco t={t} i18nKey="dashboard.funnel.configuration.common.offer_resources.course_start_access_on_day_description" components={{
                        a: <a target="_blank" className="primary-link" href={getGrantCourseAccessUrl(user?.dashboardLocale)} rel="noreferrer" />
                      }} />}>{t("dashboard.funnel.configuration.common.offer_resources.course_start_access_on_day")}</Hint>} selected={resource.accessFrom !== undefined} onChange={value_6 => onChangeResource(idx_1, {
                        type: resource.type,
                        accessFrom: value_6 ? null : undefined
                      })} />{resource.accessFrom !== undefined && <DatePicker value={resource.accessFrom || null} minDate={getToday(user?.timezone)} onChange={data_16 => onChangeResource(idx_1, {
                        type: resource.type,
                        accessFrom: data_16
                      })} timezone={user?.timezone} createdAt={user?.createdAt} intlLocale={intlLocale} />}</div></>}{resource.enrollmentAccessType && (resource.enrollmentAccessType === AccessTypeEnum.fullAccess || isPartialType(resource.enrollmentAccessType)) && <div className="flex min-h-[42px] items-center gap-5" key={`enrollment-access-type-selector-${idx_1}`}><CheckBoxSwitcher label={<Hint label={t("dashboard.funnel.configuration.common.offer_resources.course_expiration_period_popover")}>{t("dashboard.funnel.configuration.common.offer_resources.course_expiration_period")}</Hint>} selected={resource.expirationPeriod !== undefined} onChange={value_7 => onChangeResource(idx_1, {
                      type: resource.type,
                      expirationPeriod: value_7 ? 30 : undefined
                    })} />{resource.expirationPeriod !== undefined && <FormInput key={`expiration-period-selector-${idx_1}`} value={resource.expirationPeriod} onChange={e => {
                      let updatedValue = e.target.valueAsNumber;
                      if (updatedValue < 0 || isNaN(updatedValue)) {
                        updatedValue = 0;
                      }
                      onChangeResource(idx_1, {
                        type: resource.type,
                        expirationPeriod: updatedValue
                      });
                    }} type="number" min={0} />}</div>}</div></>}</DigitalResourceWrapper>;
          }
        case DigitalResourcesTypeEnum.membership_course_bundle:
          {
            return <DigitalResourceWrapper key={idx_1} resource={resource} onDelete={() => {
              onChangeResources(resources.filter((__4, i_6) => i_6 !== idx_1));
            }}>{data_10 => <><FormSelect key={`resource-type-selector-${idx_1}`} placeholder={t("dashboard.funnel.configuration.common.digital_resources.placeholder")} data={digitalResourceTypeData} onChange={data_11 => onChangeType(idx_1, data_11)} value={resource.type} /><div className="ml-4 flex flex-col gap-3"><FormSelect key={`course-bundle-selector-${idx_1}`} placeholder={t("dashboard.funnel.configuration.common.offer_resources.choose_course_bundle")} value={resource.courseBundle} data={data_10.courseBundlesData} onChange={value_3 => onChangeResource(idx_1, {
                    type: resource.type,
                    courseBundle: value_3,
                    enrollmentAccessType: null,
                    enrollmentDrippingAccessCourse: undefined
                  })} error={errors[numberOfExistingResources + idx_1]?.courseBundle?.join(", ")} />{resource.courseBundle && <FormSelect key={`course-bundle-access-type-selector-${idx_1}`} placeholder={t("dashboard.funnel.configuration.common.offer_resources.choose_course_bundle_access_type")} value={resource.enrollmentAccessType || undefined} data={courseBundleAccessData} onChange={data_12 => onChangeResource(idx_1, {
                    type: resource.type,
                    enrollmentAccessType: data_12,
                    enrollmentDrippingAccessCourse: undefined
                  })} error={errors[numberOfExistingResources + idx_1]?.enrollmentAccessType?.join(", ")} />}{resource.courseBundle && resource.enrollmentAccessType === AccessTypeEnum.drippingContent && <FormSelect key={`enrollment-dripping-course-selector-${idx_1}`} placeholder={t("dashboard.funnel.configuration.common.offer_resources.choose_dripping_course")} value={resource.enrollmentDrippingAccessCourse} data={data_10.courseBundleCoursesData} onChange={value_4 => onChangeResource(idx_1, {
                    type: resource.type,
                    enrollmentDrippingAccessCourse: value_4
                  })} error={errors[numberOfExistingResources + idx_1]?.enrollmentDrippingAccessCourse?.join(", ")} />}</div></>}</DigitalResourceWrapper>;
          }
        case DigitalResourcesTypeEnum.systemeio_plan:
          {
            return <DigitalResourceWrapper key={idx_1} resource={resource} onDelete={() => {
              onChangeResources(resources.filter((__3, i_5) => i_5 !== idx_1));
            }}>{data_8 => <><FormSelect key={`resource-type-selector-${idx_1}`} placeholder={t("dashboard.funnel.configuration.common.digital_resources.placeholder")} data={digitalResourceTypeData} onChange={data_9 => onChangeType(idx_1, data_9)} value={resource.type} /><FormSelect key={`systemeio-plan-selector-${idx_1}`} containerClassName="ml-4" value={resource.value} data={data_8.plansData} onChange={value_2 => onChangeResource(idx_1, {
                  type: resource.type,
                  value: value_2
                })} error={errors[numberOfExistingResources + idx_1]?.value?.join(", ")} placeholder={t("dashboard.funnel.configuration.common.offer_resources.choose_systeme_io_plan")} /></>}</DigitalResourceWrapper>;
          }
        case DigitalResourcesTypeEnum.systemeio_tag:
          {
            return <DigitalResourceWrapper key={idx_1} resource={resource} onDelete={() => {
              onChangeResources(resources.filter((__2, i_4) => i_4 !== idx_1));
            }}>{data_6 => <><FormSelect key={`resource-type-selector-${idx_1}`} placeholder={t("dashboard.funnel.configuration.common.digital_resources.placeholder")} data={digitalResourceTypeData} onChange={data_7 => onChangeType(idx_1, data_7)} value={resource.type} /><FormSelect key={`tag-selector-${idx_1}`} containerClassName="ml-4" placeholder={t("dashboard.funnel.configuration.common.offer_resources.choose_tag")} value={resource.value} data={data_6.tagsData} onChange={value_1 => onChangeResource(idx_1, {
                  type: resource.type,
                  value: value_1
                })} error={errors[numberOfExistingResources + idx_1]?.value?.join(", ")} /></>}</DigitalResourceWrapper>;
          }
        case DigitalResourcesTypeEnum.community_access:
          {
            return <DigitalResourceWrapper key={idx_1} resource={resource} onDelete={() => {
              onChangeResources(resources.filter((__1, i_3) => i_3 !== idx_1));
            }}>{data_4 => <><FormSelect key={`resource-type-selector-${idx_1}`} placeholder={t("dashboard.funnel.configuration.common.digital_resources.placeholder")} data={digitalResourceTypeData} onChange={data_5 => onChangeType(idx_1, data_5)} value={resource.type} /><FormSelect key={`community-access-selector-${idx_1}`} placeholder={t("dashboard.funnel.configuration.common.offer_resources.choose_community_access")} containerClassName="ml-4" value={resource.value} data={data_4.communitiesData} onChange={value_0 => onChangeResource(idx_1, {
                  type: resource.type,
                  value: value_0
                })} error={errors[numberOfExistingResources + idx_1]?.value?.join(", ")} /></>}</DigitalResourceWrapper>;
          }
        case DigitalResourcesTypeEnum.booking_event:
          {
            return <DigitalResourceWrapper key={idx_1} resource={resource} onDelete={() => {
              onChangeResources(resources.filter((__0, i_2) => i_2 !== idx_1));
            }}>{data_2 => <><FormSelect key={`resource-type-selector-${idx_1}`} placeholder={t("dashboard.funnel.configuration.common.digital_resources.placeholder")} data={digitalResourceTypeData} onChange={data_3 => onChangeType(idx_1, data_3)} value={resource.type} /><FormSelect key={`booking-event-selector-${idx_1}`} containerClassName="ml-4" placeholder={t("dashboard.digital_product.resources.booking_events.choose_event")} value={resource.value} data={data_2.eventsData} onChange={value => onChangeResource(idx_1, {
                  type: resource.type,
                  value
                })} error={errors[numberOfExistingResources + idx_1]?.value?.join(", ")} /></>}</DigitalResourceWrapper>;
          }
        default:
          {
            return <DigitalResourceWrapper key={idx_1} resource={resource} onDelete={() => {
              onChangeResources(resources.filter((_, i_1) => i_1 !== idx_1));
            }}>{() => <><FormSelect key={`resource-type-selector-${idx_1}`} placeholder={t("dashboard.funnel.configuration.common.digital_resources.placeholder")} data={digitalResourceTypeData} onChange={data_1 => onChangeType(idx_1, data_1)} value={resource.type} error={errors[numberOfExistingResources + idx_1]?.type?.join(", ")} /></>}</DigitalResourceWrapper>;
          }
      }
    });
    $[13] = courseAccessData;
    $[14] = courseBundleAccessData;
    $[15] = digitalResourceTypeData;
    $[16] = errors;
    $[17] = intlLocale;
    $[18] = numberOfExistingResources;
    $[19] = onChangeResource;
    $[20] = onChangeResources;
    $[21] = onChangeType;
    $[22] = resources;
    $[23] = t;
    $[24] = user?.createdAt;
    $[25] = user?.dashboardLocale;
    $[26] = user?.timezone;
    $[27] = t6;
  } else {
    t6 = $[27];
  }
  let t7;
  if ($[28] !== t6) {
    t7 = <>{t6}</>;
    $[28] = t6;
    $[29] = t7;
  } else {
    t7 = $[29];
  }
  return t7;
};
export default ResourcesSelect;
function _temp(el_0) {
  return el_0 !== DigitalResourcesTypeEnum.downloadable_file;
}